import React, { Component, PropTypes } from 'react';
import Disclaimer from '../Disclaimer';
import DisclaimerIndicator from '../../assets/Information.png'

class UserAmountInput extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    disclaimerContent: PropTypes.string,
    hasDisclaimer: PropTypes.bool,
    type: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    name: PropTypes.string,
    className: PropTypes.string,
    handler: PropTypes.func.isRequired,
    blurHandler: PropTypes.func
  };
  static defaultProps = {
    name: '',
    className: '',
    disclaimerContent: '',
    hasDisclaimer: false,
    blurHandler: () => { },
  };
  render() {
    const {
      title,
      disclaimerContent,
      type,
      value,
      name,
      className,
      handler,
      blurHandler,
      hasDisclaimer
    } = this.props;

    return (
      <div className="personalize-row">
        <div className="personalize-title">
          <p className="down-payment-title">
            {title}
            <span className="disclaimer-wrapper" aria-hidden={!hasDisclaimer}>
              <Disclaimer indicatorImg={DisclaimerIndicator} >
                {disclaimerContent}
              </Disclaimer>
            </span>
          </p>
        </div>
        <input
          type={type}
          className={className}
          value={value}
          name={name}
          onChange={handler}
          onBlur={blurHandler}
        />
      </div>
    )
  }
}

export default UserAmountInput;



/** WEBPACK FOOTER **
 ** ./src/components/Input/index.js
 **/